import React from "react";
import SignaturePad from 'signature_pad';
import '@css/signature.css';
import utils from '@utils/utils';

export default class SignatureCapture extends React.Component {
    constructor() {
        super();
        this.state = {
            disabled: true
        };
        this.sigDataSet = [];
    }

    render() {
        return (
            <div className="signatureContainer padding-bot-50">
                <div className="inline-block mob-center">
                    <h4>Sign and submit signature below</h4>
                </div>
                <div>
                    <canvas id={this.props.sigID} className="signatureCanvas"></canvas>
                </div>
                <div>
                    <button className="button margin-h-15" disabled={this.state.disabled} onClick={this.clearCanvas}>Clear</button>
                    <button className="button margin-h-15" disabled={this.state.disabled} onClick={this.submitSignature}>Submit</button>
                </div>  
            </div>
        );
    }

    resizeCanvas = () => {
        var ratio =  Math.max(window.devicePixelRatio || 1, 1);
        var canvas = this.canvasDocument;
        this.sigDataSet = this.signaturePad.toDataURL();
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext("2d").scale(ratio, ratio);
        /* alternate way to handle keeping image on resize.. more efficient but doesnt handle scaling positions of points to match new canvas size. */
        //this.sigDataSet = this.sigDataSet.concat(this.signaturePad.toData());
        //this.signaturePad.fromDataURL(this.sigDataSet);
        this.signaturePad.fromDataURL(this.sigDataSet);
    }

    clearCanvas = () => {
        this.disableButtons();
        this.sigDataSet = [];
        this.signaturePad.clear();
    }

    submitSignature = () => {
        if(this.props.submitSig) {
            this.disableButtons();
            this.props.submitSig(this.signaturePad.toDataURL());
        }
    }

    disableButtons = () => {
        this.setState({disabled: true});
    }

    enableButtons = () => {
        this.setState({disabled: false});
    }

    componentDidMount = () => {
        this.canvasDocument = document.getElementById(this.props.sigID);
        this.signaturePad = new SignaturePad(this.canvasDocument, {
            onBegin: function() {
                this.enableButtons();
            }.bind(this)
        });

        window.onresize = utils.debounce(this.resizeCanvas.bind(this), 500);
        this.resizeCanvas();
    }
}


// WEBPACK FOOTER //
// ./src/js/components/SignatureCapture.js